import _slicedToArray from "/vercel/path1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/vercel/path1/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.array.reduce.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __markAsModule = function __markAsModule(target) {
  return __defProp(target, "__esModule", {
    value: true
  });
};

var __export = function __export(target, all) {
  __markAsModule(target);

  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
}; // src/createDesign.ts


function createDesign(design) {
  return __spreadProps(__spreadValues({}, design), {
    createEventHandlerDesign: function createEventHandlerDesign(eventHandlerDesign) {
      return eventHandlerDesign;
    },
    createEventHandlerObjectDesign: function createEventHandlerObjectDesign(eventHandlerItemDesign) {
      return eventHandlerItemDesign;
    },
    createAsyncEventDesign: function createAsyncEventDesign(asyncEventDesign) {
      return asyncEventDesign;
    },
    createRepeatEventDesign: function createRepeatEventDesign(repeatEventDesign) {
      return repeatEventDesign;
    },
    createState: function createState(stateDesign) {
      return stateDesign;
    },
    createActionDesign: function createActionDesign(actionDesign) {
      return actionDesign;
    },
    createConditionDesign: function createConditionDesign(conditionDesign) {
      return conditionDesign;
    },
    createResultDesign: function createResultDesign(resultDesign) {
      return resultDesign;
    },
    createTimeDesign: function createTimeDesign(timeDesign) {
      return timeDesign;
    },
    createValueDesign: function createValueDesign(valueDesign) {
      return valueDesign;
    }
  });
} // src/createState.ts


import { nanoid } from "nanoid";
import { produce, enableMapSet, setAutoFreeze } from "immer"; // src/testEventHandlerConditions.ts

function testEventHandlerConditions(h, d, p, r) {
  try {
    if (h.if[0] && !h.if.every(function (c) {
      return c(d, p, r);
    })) return false;
    if (h.ifAny[0] && !h.ifAny.some(function (c) {
      return c(d, p, r);
    })) return false;
    if (h.unless[0] && !h.unless.every(function (c) {
      return !c(d, p, r);
    })) return false;
    if (h.unlessAny[0] && !h.unlessAny.some(function (c) {
      return !c(d, p, r);
    })) return false;
    return true;
  } catch (e) {
    throw Error("Error while testing conditions! " + e.message);
  }
} // src/createEventChain.ts


import { createDraft, finishDraft } from "immer"; // src/customError.ts

function customError(message, error) {
  var err = new Error(message + " " + error.message);
  err.stack = error.stack;
  return err;
} // src/createEventChain.ts


function createEventChain(options) {
  var state = options.state,
      onDelayedOutcome = options.onDelayedOutcome,
      getFreshDataAfterWait = options.getFreshDataAfterWait;

  var handlers = _toConsumableArray(options.handler);

  var payload = options.payload;
  var waiting = false;
  var core = {
    data: options.data,
    payload: options.payload,
    result: options.result
  };

  var finalOutcome = __spreadProps(__spreadValues({}, core), {
    shouldBreak: false,
    shouldNotify: false,
    pendingTransition: []
  });

  var draftCore = createDraft(core);
  var tResult = options.result;

  function complete(draft) {
    core = finishDraft(draft);
    finalOutcome.result = core.result;
    finalOutcome.data = core.data;
  }

  function processHandlerObject(handler, draft) {
    if (handler.get.length > 0) {
      var fnName = "";

      try {
        var _iterator2 = _createForOfIteratorHelper(handler.get),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var result = _step2.value;
            fnName = result.name;
            tResult = result(draft.data, payload, tResult);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } catch (e) {
        throw customError("Error in result (".concat(fnName, ")!"), e);
      }

      draft.result = tResult;
    }

    var passedConditions = testEventHandlerConditions(handler, draft.data, draft.payload, draft.result);

    if (passedConditions) {
      if (handler.do.length > 0) {
        finalOutcome.shouldNotify = true;
        var _fnName = "";

        try {
          var _iterator3 = _createForOfIteratorHelper(handler.do),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var action = _step3.value;
              _fnName = action.name;

              var _result = action(draft.data, draft.payload, draft.result);

              if (_result) {
                Object.assign(draft.data, Object.freeze(_result));
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        } catch (e) {
          throw customError("Error in action (".concat(_fnName, ")!"), e);
        }
      }

      if (handler.secretlyDo.length > 0) {
        var _fnName2 = "";

        try {
          var _iterator4 = _createForOfIteratorHelper(handler.secretlyDo),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _action = _step4.value;
              _fnName2 = _action.name;

              var _result2 = _action(draft.data, draft.payload, draft.result);

              if (_result2) {
                Object.assign(draft.data, Object.freeze(_result2));
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        } catch (e) {
          throw customError("Error in secret action (".concat(_fnName2, ")!"), e);
        }
      }

      if (handler.to.length > 0) {
        var _fnName3 = "";

        try {
          var _iterator5 = _createForOfIteratorHelper(handler.to),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var fn = _step5.value;
              _fnName3 = fn.name;
              finalOutcome.pendingTransition.push(fn(draft.data, draft.payload, draft.result));
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          finalOutcome.shouldBreak = true;
          finalOutcome.shouldNotify = true;
          return {
            shouldBreak: true
          };
        } catch (e) {
          throw customError("Error computing transition (".concat(_fnName3, ")!"), e);
        }
      }

      if (handler.secretlyTo.length > 0) {
        var _fnName4 = "";

        try {
          var _iterator6 = _createForOfIteratorHelper(handler.secretlyTo),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _fn = _step6.value;
              _fnName4 = _fn.name;
              finalOutcome.pendingTransition.push(_fn(draft.data, draft.payload, draft.result));
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          finalOutcome.shouldBreak = true;
          return {
            shouldBreak: true
          };
        } catch (e) {
          throw customError("Error computing secret transition (".concat(_fnName4, ")!"), e);
        }
      }

      if (handler.then !== void 0) {
        processEventHandler(_toConsumableArray(handler.then), draft);
      }

      if (handler.break !== void 0) {
        try {
          if (handler.break(draft.data, draft.payload, draft.result)) {
            return {
              shouldBreak: true
            };
          }
        } catch (e) {
          throw customError("Error computing break (".concat(handler.break.name, ")!"), e);
        }
      }
    } else {
      if (handler.else !== void 0) {
        processEventHandler(_toConsumableArray(handler.else), draft);
      }
    }

    return {
      shouldBreak: false
    };
  }

  function processEventHandler(eventHandler, draft) {
    if (finalOutcome.shouldBreak) {
      return {
        shouldBreakDueToWait: false
      };
    }

    var nextHandlerObject = eventHandler.shift();

    if (nextHandlerObject === void 0) {
      return {
        shouldBreakDueToWait: false
      };
    } else if (nextHandlerObject.wait !== void 0) {
      var waitTime = nextHandlerObject.wait(draft.data, payload, draft.result) * 1e3;

      if (waiting && finalOutcome.shouldNotify) {
        complete(draftCore);
        onDelayedOutcome(finalOutcome);
      }

      waiting = true;
      state.times.timeouts[0] = setTimeout(function () {
        core.data = getFreshDataAfterWait();
        core.result = void 0;
        draftCore = createDraft(core);

        var _processHandlerObject = processHandlerObject(nextHandlerObject, draftCore),
            shouldBreak = _processHandlerObject.shouldBreak;

        if (!shouldBreak) {
          var _processEventHandler = processEventHandler(handlers, draftCore),
              shouldBreakDueToWait = _processEventHandler.shouldBreakDueToWait;

          if (shouldBreakDueToWait) {
            return;
          }
        }

        complete(draftCore);
        onDelayedOutcome(finalOutcome);
      }, waitTime);
      return {
        shouldBreakDueToWait: true
      };
    } else {
      var _processHandlerObject2 = processHandlerObject(nextHandlerObject, draft),
          shouldBreak = _processHandlerObject2.shouldBreak;

      if (!shouldBreak) {
        return processEventHandler(eventHandler, draft);
      }

      return {
        shouldBreakDueToWait: false
      };
    }
  }

  processEventHandler(handlers, draftCore);
  complete(draftCore);
  return finalOutcome;
} // src/utils.ts


function last(array) {
  var length = array == null ? 0 : array.length;
  return array[length - 1];
}

function castArray(a) {
  return Array.isArray(a) ? a : [a];
} // src/stateTree.ts


function deactivateState(state) {
  state.active = false;

  for (var _i = 0, _Object$values = Object.values(state.states); _i < _Object$values.length; _i++) {
    var childState = _Object$values[_i];
    deactivateState(childState);
  }
}

function getActiveStates(state) {
  var acc = [];

  if (state.active) {
    acc.push(state);

    for (var _i2 = 0, _Object$values2 = Object.values(state.states); _i2 < _Object$values2.length; _i2++) {
      var childState = _Object$values2[_i2];
      acc.push.apply(acc, _toConsumableArray(getActiveStates(childState)));
    }
  }

  return acc;
}

function activateState(state, path, before, prev, deep) {
  var isTarget = false;
  state.active = true;

  if (state.name === path[0]) {
    path.shift();

    if (path.length === 0) {
      isTarget = true;
    }
  }

  if (state.initial === void 0) {
    Object.values(state.states).forEach(function (c) {
      return activateState(c, path, before, prev, deep);
    });
  } else if (prev && path.length === 0) {
    var c = state.states[last(state.history) || state.initial];
    activateState(c, path, before, deep, deep);
  } else if (state.states[path[0]] !== void 0) {
    var _c = state.states[path[0]];
    state.history.push(_c.name);
    activateState(_c, path, before, prev, deep);
  } else if (!isTarget && before.includes(state)) {
    var _c2 = state.states[last(state.history) || state.initial];
    activateState(_c2, path, before, false, false);
  } else {
    var _c3 = state.states[state.initial];
    state.history.push(_c3.name);
    activateState(_c3, path, before, false, false);
  }
}

function findTransitionTargets(state, path) {
  var acc = [];
  var safePath = path.startsWith(".") ? path : "." + path;

  if (state.path.endsWith(safePath)) {
    acc.push(state);
  }

  for (var _i3 = 0, _Object$values3 = Object.values(state.states); _i3 < _Object$values3.length; _i3++) {
    var childState = _Object$values3[_i3];
    acc.push.apply(acc, _toConsumableArray(findTransitionTargets(childState, path)));
  }

  return acc;
}

function getInitialState(initial, payload, data) {
  if (initial.else !== void 0) {
    var result = void 0;

    var _iterator7 = _createForOfIteratorHelper(initial.get),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var resu = _step7.value;
        result = resu(data, payload, result);
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }

    if (testEventHandlerConditions(initial, data, payload, result)) {
      if (initial.then !== void 0) {
        return getInitialState(initial.then, payload, data);
      } else {
        return initial.to(data, payload, result);
      }
    } else {
      return getInitialState(initial.else, payload, data);
    }
  } else {
    return initial.to(data, payload, void 0);
  }
}

function setIntitialStates(state, payload, data) {
  if (state.initialFn !== void 0) {
    state.initial = getInitialState(state.initialFn, payload, data);
  }

  if (state.states !== void 0) {
    for (var _i4 = 0, _Object$values4 = Object.values(state.states); _i4 < _Object$values4.length; _i4++) {
      var child = _Object$values4[_i4];
      setIntitialStates(child, payload, data);
    }
  }
}

function endStateIntervals(state) {
  var _state$times = state.times,
      cancelAsync = _state$times.cancelAsync,
      timeouts = _state$times.timeouts,
      interval = _state$times.interval,
      animationFrame = _state$times.animationFrame;

  if (cancelAsync !== void 0) {
    cancelAsync();
    state.times.cancelAsync = void 0;
  }

  var _iterator8 = _createForOfIteratorHelper(timeouts),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var timeout = _step8.value;
      clearTimeout(timeout);
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }

  state.times.timeouts = [];

  if (interval !== void 0) {
    clearInterval(interval);
    state.times.interval = void 0;
  }

  if (animationFrame !== void 0) {
    cancelAnimationFrame(animationFrame);
    state.times.animationFrame = void 0;
  }
}

function recursivelyEndStateIntervals(state) {
  endStateIntervals(state);

  for (var _i5 = 0, _Object$values5 = Object.values(state.states); _i5 < _Object$values5.length; _i5++) {
    var child = _Object$values5[_i5];
    recursivelyEndStateIntervals(child);
  }
} // src/getStateTreeFromDesign.ts


function getStateTreeFromDesign(config, id) {
  var times = Object.fromEntries(Object.entries(config.times || {}).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return [k, castToFunction(v)];
  }));

  function getEventFn(item, collection, collectionName) {
    if (typeof item === "string") {
      if (!collection) {
        throw Error("No ".concat(collectionName, " in config!"));
      } else {
        var itemFromCollection = collection[item];

        if (typeof itemFromCollection === "undefined") {
          throw Error("No item in ".concat(collectionName, " named ").concat(item, "!"));
        }

        return itemFromCollection;
      }
    } else {
      return item;
    }
  }

  function castToNamedFunction(item) {
    var fn = function fn() {
      return item;
    };

    Object.defineProperty(fn, "name", {
      value: item,
      writable: false
    });
    return fn;
  }

  function castToFunction(item) {
    if (typeof item === "undefined") return void 0;
    return typeof item === "function" ? item : castToNamedFunction(item);
  }

  function getTransitions(items) {
    if (typeof items === "undefined") return [];
    return castArray(items).map(function (item) {
      return typeof item === "function" ? item : castToNamedFunction(item);
    });
  }

  function getResults(items) {
    if (typeof items === "undefined") return [];
    return castArray(items).map(function (item) {
      return getEventFn(item, config.results, "results");
    });
  }

  function getConditions(items) {
    if (typeof items === "undefined") return [];
    return castArray(items).map(function (item) {
      return getEventFn(item, config.conditions, "conditions");
    });
  }

  function getActions(items) {
    if (typeof items === "undefined") return [];
    return castArray(items).map(function (item) {
      return getEventFn(item, config.actions, "actions");
    });
  }

  function getAsync(item) {
    return getEventFn(item, config.asyncs, "asyncs");
  }

  function getTime(item) {
    if (typeof item === "undefined") return void 0;
    return typeof item === "number" ? castToNamedFunction(item) : getEventFn(item, times, "times");
  }

  function getEventHandlerObject(itemCfg) {
    return {
      get: getResults(itemCfg.get),
      if: getConditions(itemCfg.if),
      ifAny: getConditions(itemCfg.ifAny),
      unless: getConditions(itemCfg.unless),
      unlessAny: getConditions(itemCfg.unlessAny),
      do: getActions(itemCfg.do),
      secretlyDo: getActions(itemCfg.secretlyDo),
      to: getTransitions(itemCfg.to),
      secretlyTo: getTransitions(itemCfg.secretlyTo),
      wait: getTime(itemCfg.wait),
      break: castToFunction(itemCfg.break),
      then: itemCfg.then ? getEventHandler(itemCfg.then) : void 0,
      else: itemCfg.else ? getEventHandler(itemCfg.else) : void 0
    };
  }

  function getEventHandler(event) {
    return castArray(event).map(function (eventHandler) {
      switch (typeof eventHandler) {
        case "string":
          {
            if (typeof config.actions === "undefined") {
              throw new Error("Actions is undefined!");
            } else {
              var eventFn = config.actions && config.actions[eventHandler];
              return getEventHandlerObject({
                do: eventFn
              });
            }
          }

        case "function":
          {
            return getEventHandlerObject({
              do: eventHandler
            });
          }

        default:
          {
            return getEventHandlerObject(eventHandler);
          }
      }
    });
  }

  function getInitialState2(initial) {
    if (typeof initial === "undefined") {
      return;
    }

    if (typeof initial === "string" || !("else" in initial)) {
      var target = typeof initial === "string" ? initial : initial.to;
      return {
        get: [],
        if: [],
        unless: [],
        ifAny: [],
        unlessAny: [],
        to: typeof target === "function" ? target : castToNamedFunction(target)
      };
    } else {
      return {
        get: getResults(initial.get),
        if: getConditions(initial.if),
        unless: getConditions(initial.unless),
        ifAny: getConditions(initial.ifAny),
        unlessAny: getConditions(initial.unlessAny),
        to: typeof initial.to === "function" ? initial.to : castToNamedFunction(initial.to),
        then: getInitialState2(initial.then),
        else: getInitialState2(initial.else)
      };
    }
  }

  function createState2(state, name, path, active, depth, isInitial, parentType) {
    if (state.initial !== void 0 && state.states === void 0) {
      throw Error("In ".concat(path + name, ", you've provided an initial state but no states!"));
    }

    var type = state.states ? state.initial ? "branch" : "parallel" : "leaf";
    return {
      name: name,
      type: type,
      isInitial: isInitial,
      parentType: parentType,
      depth: depth,
      path: path + name,
      active: active,
      activeId: 0,
      history: [],
      times: {
        timeouts: [],
        interval: void 0,
        animationFrame: void 0
      },
      initialFn: getInitialState2(state.initial),
      initial: void 0,
      onEnter: state.onEnter ? getEventHandler(state.onEnter) : void 0,
      onExit: state.onExit ? getEventHandler(state.onExit) : void 0,
      onEvent: state.onEvent ? getEventHandler(state.onEvent) : void 0,
      async: state.async ? {
        await: getAsync(state.async.await),
        onResolve: getEventHandler(state.async.onResolve),
        onReject: state.async.onReject ? getEventHandler(state.async.onReject) : void 0
      } : void 0,
      repeat: state.repeat ? {
        onRepeat: getEventHandler(state.repeat.onRepeat),
        delay: state.repeat.delay ? getTime(state.repeat.delay) : void 0
      } : void 0,
      on: Object.fromEntries(state.on ? Object.entries(state.on).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            name2 = _ref4[0],
            event = _ref4[1];

        return [name2, getEventHandler(event)];
      }) : []),
      states: Object.fromEntries(state.states ? Object.entries(state.states).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            childName = _ref6[0],
            childState = _ref6[1];

        return [childName, createState2(childState, childName, path + name + ".", false, depth + 1, state.initial === childName, type)];
      }) : [])
    };
  }

  return createState2(config, "root", id + ".", true, 0, true, null);
} // src/createState.ts


enableMapSet();
setAutoFreeze(false);

function createState(design) {
  var _a;

  var _design$options = design.options,
      options = _design$options === void 0 ? {} : _design$options;
  var _options$suppressErro = options.suppressErrors,
      suppressErrors = _options$suppressErro === void 0 ? false : _options$suppressErro,
      onSend = options.onSend;
  var logEnabled = (_a = design.options) == null ? void 0 : _a.enableLog;

  function handleError(err, prefix) {
    var _a2;

    if (prefix) {
      err.message = prefix + ": " + err.message;
    }

    if ((_a2 = design.options) == null ? void 0 : _a2.onError) {
      design.options.onError(err);
    }

    if (suppressErrors) {
      throw err;
    } else {
      throw err;
    }
  }

  var subscribers = new Set([]);

  function subscribe(callbackFn) {
    subscribers.add(callbackFn);
  }

  function unsubscribe(callbackFn) {
    if (subscribers.has(callbackFn)) {
      subscribers.delete(callbackFn);
    }

    if (subscribers.size === 0) {
      stopLoop();
      recursivelyEndStateIntervals(snapshot.stateTree);
    }
  }

  function notifySubscribers() {
    setValues();
    setLog();
    setActiveStates();
    subscribers.forEach(function (subscriber) {
      return subscriber(snapshot);
    });
  }

  function handleEventHandlerChainOutcome(outcome, payload) {
    snapshot.data = outcome.data;

    var _iterator9 = _createForOfIteratorHelper(outcome.pendingTransition),
        _step9;

    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var transition = _step9.value;
        runTransition(transition, payload, outcome.result);
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  }

  function runEventHandlerChain(state, eventHandler, payload, result) {
    var outcome = createEventChain({
      state: state,
      data: snapshot.data,
      result: result,
      payload: payload,
      handler: eventHandler,
      onDelayedOutcome: function onDelayedOutcome(outcome2) {
        handleEventHandlerChainOutcome(outcome2, payload);

        if (outcome2.shouldNotify) {
          notifySubscribers();
        }
      },
      getFreshDataAfterWait: function getFreshDataAfterWait() {
        return snapshot.data;
      }
    });
    handleEventHandlerChainOutcome(outcome, payload);
    return outcome;
  }

  function handleEventOnState(state, sent) {
    var record = {
      shouldHalt: false,
      shouldNotify: false
    };
    if (!state.active) return record;
    var activeChildren = Object.values(state.states).filter(function (state2) {
      return state2.active;
    });
    var eventHandler = state.on[sent.event];
    var outcome = void 0;

    if (typeof eventHandler !== "undefined") {
      outcome = runEventHandlerChain(state, eventHandler, sent.payload, void 0);

      if (outcome.shouldNotify) {
        record.shouldNotify = true;
      }

      if (outcome.shouldBreak) {
        record.shouldNotify = true;
        record.shouldHalt = true;
        return record;
      }
    }

    if (typeof state.onEvent !== "undefined") {
      outcome = runEventHandlerChain(state, state.onEvent, sent.payload, outcome == null ? void 0 : outcome.result);

      if (outcome.shouldNotify) {
        record.shouldNotify = true;
      }

      if (outcome.shouldBreak) {
        record.shouldNotify = true;
        record.shouldHalt = true;
        return record;
      }
    }

    var _iterator10 = _createForOfIteratorHelper(activeChildren),
        _step10;

    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var childState = _step10.value;
        var childRecord = handleEventOnState(childState, sent);

        if (childRecord.shouldNotify) {
          record.shouldNotify = true;
        }

        if (childRecord.shouldHalt) {
          record.shouldNotify = true;
          record.shouldHalt = true;
          return record;
        }
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }

    return record;
  }

  function runTransition(path, payload, result) {
    var isPreviousTransition = path.endsWith(".previous");
    var isRestoreTransition = path.endsWith(".restore");

    if (isPreviousTransition) {
      path = path.slice(0, path.length - 9);
    } else if (isRestoreTransition) {
      path = path.slice(0, path.length - 8);
    }

    var targets = findTransitionTargets(snapshot.stateTree, path);
    var target = last(targets);

    if (typeof target === "undefined") {
      throw Error("Error in transition (".concat(path, ")! Could not find that state."));
    }

    var pathDown = target.path.split(".").slice(1);
    var beforeActive = getActiveStates(snapshot.stateTree);
    deactivateState(snapshot.stateTree);
    setIntitialStates(snapshot.stateTree, payload, snapshot.data);
    activateState(snapshot.stateTree, pathDown, beforeActive, isPreviousTransition || isRestoreTransition, isRestoreTransition);
    var afterActive = getActiveStates(snapshot.stateTree);
    var deactivatedStates = beforeActive.filter(function (state) {
      return !afterActive.includes(state);
    });
    var newlyActivatedStates = afterActive.filter(function (state) {
      return !beforeActive.includes(state);
    });
    deactivatedStates.forEach(function (state) {
      endStateIntervals(state);
      removeOnFrameEventHandler(state);
    });

    var _iterator11 = _createForOfIteratorHelper(deactivatedStates),
        _step11;

    try {
      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        var state = _step11.value;
        var onExit = state.onExit;
        state.activeId++;

        if (typeof onExit !== "undefined") {
          var onExitOutcome = runEventHandlerChain(state, onExit, payload, result);
          if (onExitOutcome.shouldBreak) return;
        }
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }

    var _iterator12 = _createForOfIteratorHelper(newlyActivatedStates),
        _step12;

    try {
      var _loop = function _loop() {
        var state = _step12.value;
        var async = state.async,
            repeat = state.repeat,
            onEnter = state.onEnter;

        if (typeof repeat !== "undefined") {
          var onRepeat = repeat.onRepeat,
              delay = repeat.delay;
          var now = performance.now();
          var elapsed = 0;
          var realInterval = 0;

          if (delay === void 0) {
            addOnFrameState(state, {
              payload: payload,
              start: now
            });
          } else {
            var lastTime2 = performance.now();
            var s = delay(snapshot.data, payload, result);
            state.times.interval = setInterval(function () {
              now = performance.now();
              realInterval = now - lastTime2;
              elapsed += realInterval;
              lastTime2 = now;
              var outcome = runEventHandlerChain(state, onRepeat, payload, {
                interval: realInterval,
                elapsed: elapsed
              });
              if (outcome.shouldNotify) notifySubscribers();
            }, Math.max(1 / 60, s * 1e3));
          }
        }

        if (typeof onEnter !== "undefined") {
          var onEnterOutcome = runEventHandlerChain(state, onEnter, payload, result);
          if (onEnterOutcome.shouldBreak) return {
            v: void 0
          };
        }

        if (typeof async !== "undefined") {
          var finished = false;

          state.times.cancelAsync = function () {
            return finished = true;
          };

          async.await(snapshot.data, payload, result).then(function (resolved) {
            if (finished) return;
            var localUpdate = runEventHandlerChain(state, async.onResolve, payload, resolved);
            if (localUpdate.shouldNotify) notifySubscribers();
          }, function (rejected) {
            if (typeof async.onReject !== "undefined") {
              if (finished) return;
              var localUpdate = runEventHandlerChain(state, async.onReject, payload, rejected);
              if (localUpdate.shouldNotify) notifySubscribers();
            }
          });
        }
      };

      for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
        var _ret = _loop();

        if (typeof _ret === "object") return _ret.v;
      }
    } catch (err) {
      _iterator12.e(err);
    } finally {
      _iterator12.f();
    }
  }

  function enableLog(enabled) {
    logEnabled = enabled;
  }

  function logEvent(event) {
    if (logEnabled) {
      _log.unshift(event);
    } else {
      _log = [event];
    }
  }

  function setLog() {
    snapshot.index++;
    snapshot.log = _toConsumableArray(_log);
  }

  function setValues() {
    snapshot.values = getValues(snapshot.data, design.values);
  }

  function setActiveStates() {
    _activeStates = getActiveStates(snapshot.stateTree);
    snapshot.active = getPaths(_activeStates);
  }

  var lastTime = -1;
  var interval = -1;
  var frameInterval = void 0;
  var onFrameStates = new Map([]);

  function loop(ms) {
    var _a2;

    var shouldNotify = false;
    if (lastTime < 0) lastTime = ms;
    interval = ms - lastTime;
    lastTime = ms;
    var states = Array.from(onFrameStates.entries());

    for (var _i6 = 0, _states = states; _i6 < _states.length; _i6++) {
      var _states$_i = _slicedToArray(_states[_i6], 2),
          state = _states$_i[0],
          info = _states$_i[1];

      if (((_a2 = state.repeat) == null ? void 0 : _a2.onRepeat) !== void 0) {
        var outcome = runEventHandlerChain(state, state.repeat.onRepeat, info.payload, {
          interval: interval,
          elapsed: ms - info.start
        });

        if (outcome.shouldNotify) {
          shouldNotify = true;
        }

        if (outcome.shouldBreak) {
          break;
        }
      }
    }

    if (shouldNotify) notifySubscribers();
    if (frameInterval === void 0) return;
    frameInterval = requestAnimationFrame(loop);
  }

  function stopLoop() {
    if (frameInterval !== void 0) {
      cancelAnimationFrame(frameInterval);
      frameInterval = void 0;
      lastTime = -1;
      interval = -1;
    }
  }

  function startLoop() {
    frameInterval = requestAnimationFrame(loop);
  }

  function addOnFrameState(state, info) {
    onFrameStates.set(state, info);

    if (frameInterval === void 0) {
      startLoop();
    }
  }

  function removeOnFrameEventHandler(state) {
    if (onFrameStates.has(state)) {
      onFrameStates.delete(state);

      if (onFrameStates.size === 0) {
        stopLoop();
      }
    }
  }

  function onUpdate(callbackFn) {
    subscribe(callbackFn);
    return function () {
      return unsubscribe(callbackFn);
    };
  }

  function getUpdate(callbackFn) {
    setValues();
    setActiveStates();
    setLog();
    callbackFn(snapshot);
  }

  function send(eventName, payload, onSettle) {
    try {
      var _handleEventOnState = handleEventOnState(snapshot.stateTree, {
        event: eventName,
        payload: payload
      }),
          shouldNotify = _handleEventOnState.shouldNotify;

      logEvent(eventName);
      if (shouldNotify) notifySubscribers();
      onSettle == null ? void 0 : onSettle(snapshot);
      onSend == null ? void 0 : onSend(eventName, payload, shouldNotify);
    } catch (e) {
      handleError(e, eventName);
    }

    return snapshot;
  }

  var sendCache = new Map([]);

  function thenSend(eventName) {
    var cached = sendCache.get(eventName);

    if (!cached) {
      cached = function cached() {
        return send(eventName);
      };

      sendCache.set(eventName, cached);
    }

    return cached;
  }

  function isIn() {
    for (var _len = arguments.length, paths = new Array(_len), _key = 0; _key < _len; _key++) {
      paths[_key] = arguments[_key];
    }

    try {
      return castArray(paths).map(function (path) {
        return path.startsWith(".") ? path : "." + path;
      }).every(function (path) {
        return _activeStates.find(function (state) {
          return state.path.endsWith(path);
        }) !== void 0;
      });
    } catch (e) {
      handleError(customError("Error testing isIn(".concat(paths.join(), ")!"), e));
      return false;
    }
  }

  function isInAny() {
    for (var _len2 = arguments.length, paths = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      paths[_key2] = arguments[_key2];
    }

    try {
      return castArray(paths).map(function (path) {
        return path.startsWith(".") ? path : "." + path;
      }).some(function (path) {
        return _activeStates.find(function (state) {
          return state.path.endsWith(path);
        }) !== void 0;
      });
    } catch (e) {
      handleError(customError("Error testing isInAny(".concat(paths.join(), ")!"), e));
      return false;
    }
  }

  function can(eventName, payload, result) {
    return typeof _activeStates.find(function (state) {
      var eventHandler = state.on[eventName];
      if (typeof eventHandler === "undefined") return;

      try {
        return eventHandler.some(function (handler) {
          result = void 0;

          var _iterator13 = _createForOfIteratorHelper(handler.get),
              _step13;

          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              var resu = _step13.value;
              result = resu(snapshot.data, payload, result);
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }

          return testEventHandlerConditions(handler, snapshot.data, payload, result);
        });
      } catch (e) {
        handleError(customError("Error testing can(".concat(eventName, ")!"), e));
        return false;
      }
    }) !== "undefined";
  }

  function whenIn(paths) {
    var reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "value";
    var initialValue = arguments.length > 2 ? arguments[2] : undefined;
    var entries = [];
    Object.entries(paths).forEach(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          key = _ref8[0],
          value = _ref8[1];

      var v = typeof value === "function" ? value() : value;

      if (key === "root") {
        entries.push([key, v]);
      } else {
        if (_activeStates.find(function (v2) {
          var safeKey = key.startsWith(".") ? key : "." + key;
          return v2.path.endsWith(safeKey);
        })) {
          entries.push([key, v]);
        }
      }
    });

    if (entries.length === 0) {
      if (typeof paths.default !== "undefined") {
        entries.push(["default", paths.default]);
      }
    }

    var returnValue;
    var rdcr;

    if (reducer === "array") {
      returnValue = [];

      rdcr = function rdcr(a, _ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
            _ = _ref10[0],
            v = _ref10[1];

        return [].concat(_toConsumableArray(a), [v]);
      };
    } else if (reducer === "value") {
      returnValue = void 0;

      rdcr = function rdcr(_, _ref11) {
        var _ref12 = _slicedToArray(_ref11, 2),
            __ = _ref12[0],
            v = _ref12[1];

        return v;
      };
    } else {
      returnValue = initialValue;
      rdcr = reducer;
    }

    entries.forEach(function (entry, i) {
      return returnValue = rdcr(returnValue, entry, i, entries);
    });
    return returnValue;
  }

  function getDesign() {
    return design;
  }

  function clone() {
    return createState(design);
  }

  function forceTransition(target, payload) {
    logEvent("Forced transition to: ".concat(target));
    runTransition(target, payload, void 0);
    notifySubscribers();
    return snapshot;
  }

  function forceData(data) {
    snapshot.data = data;
    logEvent("Forced data.");
    notifySubscribers();
    return snapshot;
  }

  function reset() {
    stopLoop();
    recursivelyEndStateIntervals(snapshot.stateTree);
    _log = [];
    Object.assign(snapshot, {
      data: produce(design.data, function (d) {
        return d;
      }),
      stateTree: getStateTreeFromDesign(design, id),
      log: []
    });
    deactivateState(snapshot.stateTree);
    runTransition("root", void 0, void 0);
    notifySubscribers();
    return snapshot;
  }

  var id = "#" + (typeof design.id !== "undefined" ? "state_".concat(nanoid()) : design.id);
  var initialStateTree = getStateTreeFromDesign(design, id);
  var _log = [];

  var _activeStates = getActiveStates(initialStateTree);

  var snapshot = {
    id: id,
    data: produce(design.data, function (d) {
      return d;
    }),
    active: getPaths(_activeStates),
    values: getValues(design.data, design.values),
    stateTree: initialStateTree,
    log: _log,
    index: 0,
    send: send,
    thenSend: thenSend,
    isIn: isIn,
    isInAny: isInAny,
    can: can,
    whenIn: whenIn,
    getDesign: getDesign,
    onUpdate: onUpdate,
    getUpdate: getUpdate,
    enableLog: enableLog,
    forceData: forceData,
    forceTransition: forceTransition,
    clone: clone,
    reset: reset
  };
  deactivateState(snapshot.stateTree);
  runTransition("root", void 0, void 0);
  setValues();
  setActiveStates();
  setLog();
  return snapshot;
}

function getPaths(states) {
  return states.map(function (state) {
    return state.path;
  });
}

function getValues(data, values) {
  return Object.entries(values || {}).reduce(function (acc, _ref13) {
    var _ref14 = _slicedToArray(_ref13, 2),
        key = _ref14[0],
        fn = _ref14[1];

    acc[key] = fn(data);
    return acc;
  }, {});
} // src/types.ts


var types_exports = {};

__export(types_exports, {
  VerboseType: function VerboseType() {
    return _VerboseType;
  }
});

var _VerboseType;

(function (VerboseType2) {
  VerboseType2["Condition"] = "condition";
  VerboseType2["Action"] = "action";
  VerboseType2["SecretAction"] = "secretAction";
  VerboseType2["Event"] = "event";
  VerboseType2["State"] = "state";
  VerboseType2["AsyncEvent"] = "asyncEvent";
  VerboseType2["TransitionEvent"] = "transitionEvent";
  VerboseType2["RepeatEvent"] = "repeatEvent";
  VerboseType2["Transition"] = "transition";
  VerboseType2["Notification"] = "notification";
  VerboseType2["EventHandler"] = "eventHandler";
  VerboseType2["Queue"] = "queue";
})(_VerboseType || (_VerboseType = {}));

export { types_exports as S, createDesign, createState };